import { PlaceholderText } from 'components/Placeholders';
import Stack from 'components/Stack';

/**
 * The frame every entity page draws: breadcrumbs, the data-source tabs, the
 * heading row, then the page's own content and its hash-linked tab strip.
 *
 * Omit `title` to draw your own hero: `children` then becomes a direct `Stack`
 * child rather than sitting in the heading row's column.
 */
function EntityPageShell({
    breadcrumbs = null,
    tabs = null,
    title,
    actions = null,
    space = '24px',
    children,
    sections = null,
}) {
    return (
        <>
            {breadcrumbs ? (
                <div css="position: relative; z-index: 1;">{breadcrumbs}</div>
            ) : null}
            {tabs}
            <Stack $space={space}>
                {title ? (
                    <div className="flex flex-col gap-3">
                        <div className="flex items-start justify-between gap-3 px-1">
                            <div className="flex flex-col gap-0.5 min-w-0 flex-1">
                                <h1 className="text-2xl font-bold capitalize m-0 truncate">
                                    {title.name ||
                                        (title.isLoading ? (
                                            <PlaceholderText />
                                        ) : (
                                            '–'
                                        ))}
                                </h1>
                            </div>
                            {actions ? (
                                <div className="flex items-center gap-2 shrink-0">
                                    {actions}
                                </div>
                            ) : null}
                        </div>
                        {children}
                    </div>
                ) : (
                    children
                )}
                {sections}
            </Stack>
        </>
    );
}

export default EntityPageShell;
